import request from '@/middleware/request'

const getQueue = () => {
  return request({
    url: '/queues',
    method: 'get'
  })
}

const getQueueVoice = () => {
  return request({
    url: '/queues/voice',
    method: 'get'
  })
}

const getQueueChat = () => {
  return request({
    url: '/queues/chat',
    method: 'get'
  })
}

const createQueue = data => {
  return request({
    url: '/queues',
    method: 'post',
    data
  })
}

const updateQueue = (id, data) => {
  return request({
    url: `/queues/${id}`,
    method: 'patch',
    data
  })
}

const deleteQueue = id => {
  return request({
    url: `/queues/${id}`,
    method: 'delete'
  })
}

const getName = () => {
  return request({
    url: '/queues/names',
    method: 'get'
  })
}

export default {
  getQueue,
  getQueueVoice,
  getQueueChat,
  createQueue,
  updateQueue,
  deleteQueue,
  getName
}
